export const ROUTE_PLAN_PRECHECKOUT = '/survey/plan/';
export const ROUTE_PLAN = '/plan/';
